import { AlignmentType, BorderStyle, HeadingLevel, ImageRun, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, TextWrappingSide, TextWrappingType, VerticalAlign, WidthType } from "docx";


export function summaryTextNetwork1(certInNetworkVulCount) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 250, after: 200 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `During the Vulnerability Assessment and Penetration Testing exercise, ISECURION security testing team (hereafter referred as the ‘testing team’) identified ${certInNetworkVulCount} vulnerabilities in the internal network environment. To enable risk-focused mitigation these vulnerabilities are summarized in three different categories. The categorization of the identified vulnerability will assist the IT team, to define the priority for the mitigation process. `,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}

export const summarytext2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "On the basis of severity risk ratings, the testing team classified the identified vulnerabilities as below:",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics:false
        }),
    ],
})

export function severityLevelTableNetwork(certInNetworkCritical, certInNetworkHigh, certInNetworkMedium, certInNetworkLow){
    return new Table({
       width: { size: 60, type: WidthType.PERCENTAGE },
       alignment: AlignmentType.CENTER,
       spacing: { before: 1200 },
       borders: {
           top: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8"},
           bottom: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8"},
           left: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
           right: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
       },

       rows: [
           new TableRow({
               children: [
                   new TableCell({
                       width: { size: 13, type: WidthType.PERCENTAGE },
                       children: [
                           new Paragraph({
                               spacing: { before: 110, after: 110 },
                               alignment: AlignmentType.CENTER,
                               children: [
                                   new TextRun({
                                       text: "Sl. No",
                                       font: "Calibri",
                                       size: 22,
                                       color: "ffffff",
                                       bold: true,
                                       italics: false
                                   })
                               ]
                           })],
                       shading: { type: ShadingType.SOLID, color: "003366" },
                       indent: { left: 800 },
                       borders: {
                           top: { style: BorderStyle.THICK, size: 3*8,color:"f8f8f8"},
                           bottom: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                           left: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                           right: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                       },
                   }),

                   new TableCell({
                       width: { size: 59, type: WidthType.PERCENTAGE },
                       children: [
                           new Paragraph({
                               spacing: { before: 110, after: 110 },
                               alignment: AlignmentType.CENTER,
                               children: [
                                   new TextRun({
                                       text: "Severity Level",
                                       font: "Calibri",
                                       size: 22,
                                       color: "ffffff",
                                       bold: true,
                                       italics: false
                                   })
                               ]
                           })],
                       shading: {
                           type: ShadingType.SOLID,
                           color: "003366",
                       },
                       borders: {
                           top: { style: BorderStyle.THICK, size: 3*8,color:"f8f8f8"},
                           bottom: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                           left: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                           right: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                       },
                   }),

                   new TableCell({
                       width: { size: 28, type: WidthType.PERCENTAGE },
                       children: [
                           new Paragraph({
                               spacing: { before: 110, after: 110 },
                               alignment: AlignmentType.CENTER,
                               children: [
                                   new TextRun({
                                       text: "Frequency",
                                       font: "Calibri",
                                       size: 22,
                                       color: "ffffff",
                                       bold: true,
                                       italics: false
                                   })
                               ]
                           })],
                       shading: {
                           type: ShadingType.SOLID,
                           color: "003366",
                       },
                       borders: {
                           top: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8"},
                           bottom: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8"},
                           left: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                           right: { style: BorderStyle.THICK, size: 3*8,color:"f8f8f8" },
                       },
                   }),
               ]
           }),

           new TableRow({
               children: [
                   new TableCell({
                       children: [
                           new Paragraph({
                               spacing: { before: 100, after: 100 },
                               alignment: AlignmentType.CENTER,
                               children: [
                                   new TextRun({
                                       text: "1",
                                       font: "Calibri",
                                       size: 22,
                                       color: '000000',
                                       italics: false,
                                       bold: true,
                                   })
                               ]
                           })],

                       borders: {
                           top: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                           bottom: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8"},
                           left: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8"},
                           right: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8"},
                       },
                   }),

                   new TableCell({
                       children: [
                           new Paragraph({
                               spacing: { before: 100, after: 100 },
                               indent:{ left: 80},
                               alignment: AlignmentType.LEFT,
                               children: [
                                   new TextRun({
                                       text: "Critical",
                                       font: "Calibri",
                                       size: 22,
                                       color: '000000',
                                       italics: false,
                                       bold: true,
                                   }),
                               ]
                           })],

                       borders: {
                           top: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                           bottom: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                           left: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                           right: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                       },
                   }),

                   new TableCell({
                       children: [
                           new Paragraph({
                               spacing: { before: 100, after: 100 },
                               alignment: AlignmentType.CENTER,
                               children: [
                                   new TextRun({
                                       text: certInNetworkCritical,
                                       font: "Calibri",
                                       size: 22,
                                       color: '000000',
                                       italics: false,
                                       bold: true,
                                   }),
                               ]
                           })],

                       borders: {
                           top: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                           bottom: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                           left: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                           right: { style: BorderStyle.THICK, size: 3*8, color:"f8f8f8" },
                       },
                   }),
               ]
           }),

           new TableRow({
               children: [
                   new TableCell({
                       children: [
                           new Paragraph({
                               spacing: { before: 100, after: 100 },
                               alignment: AlignmentType.CENTER,
                               children: [
                                   new TextRun({
                                       text: "2",
                                       font: "Calibri",
                                       size: 22,
                                       color: '000000',
                                       italics: false,
                                       bold: true,
                                   })
                               ]
                           })],

                       borders: {
                           top: { style: BorderStyle.SINGLE, size: 3*8, color:"f8f8f8" },
                           bottom: { style: BorderStyle.SINGLE, size: 3*8, color:"f8f8f8" },
                           left: { style: BorderStyle.SINGLE, size: 3*8, color:"f8f8f8"},
                           right: { style: BorderStyle.SINGLE, size: 3*8, color:"f8f8f8"},
                       },
                   }),

                   new TableCell({
                       children: [
                           new Paragraph({
                               spacing: { before: 100, after: 100 },
                               indent:{ left: 80},
                               alignment: AlignmentType.LEFT,
                               children: [
                                   new TextRun({
                                       text: "High",
                                       font: "Calibri",
                                       size: 22,
                                       color: '000000',
                                       italics: false,
                                       bold: true,
                                   }),
                               ]
                           })],

                       borders: {
                           top: { style: BorderStyle.SINGLE, size: 3*8, color:"f8f8f8" },
                           bottom: { style: BorderStyle.SINGLE, size: 3*8, color:"f8f8f8" },
                           left: { style: BorderStyle.SINGLE, size: 3*8, color:"f8f8f8" },
                           right: { style: BorderStyle.SINGLE, size: 3*8, color:"f8f8f8"},
                       },
                   }),

                   new TableCell({
                       children: [
                           new Paragraph({
                               spacing: { before: 100, after: 100 },
                               alignment: AlignmentType.CENTER,
                               children: [
                                   new TextRun({
                                       text: certInNetworkHigh,
                                       font: "Calibri",
                                       size: 22,
                                       color: '000000',
                                       italics: false,
                                       bold: true,
                                   }),
                               ]
                           })],

                       borders: {
                           top: { style: BorderStyle.SINGLE, size: 3*8, color:"f8f8f8"},
                           bottom: { style: BorderStyle.SINGLE, size: 3*8, color:"f8f8f8" },
                           left: { style: BorderStyle.SINGLE, size: 3*8, color:"f8f8f8"},
                           right: { style: BorderStyle.SINGLE, size: 3*8, color:"f8f8f8"},
                       },
                   }),
               ]
           }),

           new TableRow({
               children: [
                   new TableCell({
                       children: [
                           new Paragraph({
                               spacing: { before: 100, after: 100 },
                               alignment: AlignmentType.CENTER,
                               children: [
                                   new TextRun({
                                       text: "3",
                                       font: "Calibri",
                                       size: 22,
                                       color: '000000',
                                       italics: false,
                                       bold: true,
                                   })
                               ]
                           })],

                       borders: {
                           top: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                           bottom: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                           left: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                           right: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8"  },
                       },
                   }),

                   new TableCell({
                       children: [
                           new Paragraph({
                               spacing: { before: 100, after: 100 },
                               indent:{ left: 80},
                               alignment: AlignmentType.LEFT,
                               children: [
                                   new TextRun({
                                       text: "Medium",
                                       font: "Calibri",
                                       size: 22,
                                       color: '000000',
                                       italics: false,
                                       bold: true,
                                   }),
                               ]
                           })],

                       borders: {
                           top: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8"  },
                           bottom: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8"  },
                           left: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8"  },
                           right: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                       },
                   }),

                   new TableCell({
                       children: [
                           new Paragraph({
                               spacing: { before: 100, after: 100 },
                               alignment: AlignmentType.CENTER,
                               children: [
                                   new TextRun({
                                       text: certInNetworkMedium,
                                       font: "Calibri",
                                       size: 22,
                                       color: '000000',
                                       italics: false,
                                       bold: true,
                                   }),
                               ]
                           })],

                       borders: {
                           top: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                           bottom: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                           left: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8"  },
                           right: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8"  },
                       },
                   }),
               ]
           }),

           new TableRow({
               children: [
                   new TableCell({
                       children: [
                           new Paragraph({
                               spacing: { before: 100, after: 100 },
                               alignment: AlignmentType.CENTER,
                               children: [
                                   new TextRun({
                                       text: "4",
                                       font: "Calibri",
                                       size: 22,
                                       color: '000000',
                                       italics: false,
                                       bold: true,
                                   })
                               ]
                           })],

                       borders: {
                           top: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                           bottom: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                           left: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8"  },
                           right: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                       },
                   }),

                   new TableCell({
                       children: [
                           new Paragraph({
                               spacing: { before: 100, after: 100 },
                               indent:{ left: 80},
                               alignment: AlignmentType.LEFT,
                               children: [
                                   new TextRun({
                                       text: "Low",
                                       font: "Calibri",
                                       size: 22,
                                       color: '000000',
                                       italics: false,
                                       bold: true,
                                   }),
                               ]
                           })],

                       borders: {
                           top: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                           bottom: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                           left: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                           right: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8"  },
                       },
                   }),

                   new TableCell({
                       children: [
                           new Paragraph({
                               spacing: { before: 100, after: 100 },
                               alignment: AlignmentType.CENTER,
                               children: [
                                   new TextRun({
                                       text: certInNetworkLow,
                                       font: "Calibri",
                                       size: 22,
                                       color: '000000',
                                       italics: false,
                                       bold: true,
                                   }),
                               ]
                           })],

                       borders: {
                           top: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8"  },
                           bottom: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                           left: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                           right: { style: BorderStyle.SINGLE, size: 3*8, color: "f8f8f8" },
                       },
                   }),
               ]
           }),
       ]
   })
   }
